const routers = [
  {
    path: '/',
    component: resolve => require(['../pages/Index/Index'], resolve),
    name: 'Index',
    meta: {
      isHeader:true,
			isFooter:true
    }
  },
	{
	  path: '/wisdomparking',							//智慧停车
	  component: resolve => require(['../pages/WisdomParking/WisdomParking'], resolve),
	  name: 'wisdomparking',
	  meta: {
	    isHeader:true,
			isFooter:true
	  }
	},
	{
	  path: '/wisdomparking/wgtc',				//无感停车
	  component: resolve => require(['../pages/WisdomParking/SolutionWgtc'], resolve),
	  name: 'wgtc',
	  meta: {
	    isHeader:true,
			isFooter:true
	  }
	},
	{
	  path: '/wisdomparking/zxzf',				//在线支付
	  component: resolve => require(['../pages/WisdomParking/SolutionZxzf'], resolve),
	  name: 'Zxzf',
	  meta: {
	    isHeader:true,
			isFooter:true
	  }
	},
	{
	  path: '/wisdomparking/tccyz',				//停车场业主
	  component: resolve => require(['../pages/WisdomParking/CooperationTccyz'], resolve),
	  name: 'Tccyz',
	  meta: {
	    isHeader:true,
			isFooter:true
	  }
	},
	{
	  path: '/wisdomparking/fws',				//服务商
	  component: resolve => require(['../pages/WisdomParking/CooperationFws'], resolve),
	  name: 'fws',
	  meta: {
	    isHeader:true,
			isFooter:true
	  }
	},
	{
	  path: '/wisdomparking/wss',				//我 是谁
	  component: resolve => require(['../pages/WisdomParking/CooperationWss'], resolve),
	  name: 'wss',
	  meta: {
	    isHeader:true,
			isFooter:true
	  }
	},
	{
	  path: '/educationexpends',				//教育缴费
	  component: resolve => require(['../pages/EducationExpends/EducationExpends'], resolve),
	  name: 'educationexpends',
	  meta: {
	    isHeader:true,
			isFooter:true
	  }
	},
	{
	  path: '/educationexpends/paymenthall',				//缴费大厅
	  component: resolve => require(['../pages/EducationExpends/PaymentHall'], resolve),
	  name: 'paymenthall',
	  meta: {
	    isHeader:true,
			isFooter:true
	  }
	},
	{
	  path: '/educationexpends/CampusCard',				//电子校园卡
	  component: resolve => require(['../pages/EducationExpends/CampusCard'], resolve),
	  name: 'CampusCard',
	  meta: {
	    isHeader:true,
			isFooter:true
	  }
	},
	{
	  path: '/RapidExploit',				//开速开发
	  component: resolve => require(['../pages/RapidExploit/RapidExploit'], resolve),
	  name: 'RapidExploit',
	  meta: {
	    isHeader:true,
			isFooter:true
	  }
	},
	{
	  path: '/RapidExploit/CaseDetile',				//案例展示
	  component: resolve => require(['../pages/RapidExploit/CaseDetile'], resolve),
	  name: 'CaseDetile',
	  meta: {
	    isHeader:true,
			isFooter:true
	  }
	},
	{
	  path: '/login',				//注册
	  component: resolve => require(['../pages/RegLogin/Login'], resolve),
	  name: 'login',
	  meta: {
	    isHeader:false,
			isFooter:false
	  }
	},
	{
	  path: '/reg',				//注册
	  component: resolve => require(['../pages/RegLogin/Reg'], resolve),
	  name: 'reg',
	  meta: {
	    isHeader:false,
			isFooter:false
	  }
	}
]
export default routers



// WEBPACK FOOTER //
// ./src/router/routers.js